"use client";

import type { ComponentPropsWithoutRef } from "react";
import { Play } from "lucide-react";

import { cn } from "@/lib/utils";

export const GLASS_PLAY_BUTTON_CLASS =
	"pointer-events-auto inline-flex items-center justify-center rounded-full bg-white/20 text-white shadow-[0_10px_30px_rgba(0,0,0,0.22)] backdrop-blur-sm transition hover:scale-105 hover:bg-white/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary";

export const GLASS_PLAY_ICON_CLASS = "ml-0.5 !fill-white !text-white !stroke-white";

const GLASS_PLAY_BUTTON_SIZES = {
	md: {
		button: "size-12",
		icon: "size-5",
	},
	lg: {
		button: "size-14",
		icon: "size-6",
	},
} as const;

type GlassPlayButtonProps = Omit<ComponentPropsWithoutRef<"button">, "children"> & {
	size?: keyof typeof GLASS_PLAY_BUTTON_SIZES;
	iconClassName?: string;
};

export default function GlassPlayButton({
	size = "md",
	className,
	iconClassName,
	type = "button",
	...props
}: GlassPlayButtonProps) {
	const sizeClasses = GLASS_PLAY_BUTTON_SIZES[size];

	return (
		<button
			type={type}
			className={cn(GLASS_PLAY_BUTTON_CLASS, sizeClasses.button, className)}
			{...props}
		>
			<Play
				className={cn(GLASS_PLAY_ICON_CLASS, sizeClasses.icon, iconClassName)}
				aria-hidden
			/>
		</button>
	);
}
